import { CheckCircle, XCircle, Info, AlertTriangle } from 'lucide-react';

type AlertType = 'success' | 'error' | 'info' | 'warning';

const STYLES: Record<AlertType, { bg: string; border: string; text: string; Icon: typeof CheckCircle }> = {
  success: {
    bg: 'bg-green-50 dark:bg-green-900/20',
    border: 'border-green-200 dark:border-green-800',
    text: 'text-green-700 dark:text-green-300',
    Icon: CheckCircle,
  },
  error: {
    bg: 'bg-red-50 dark:bg-red-900/20',
    border: 'border-red-200 dark:border-red-800',
    text: 'text-red-700 dark:text-red-300',
    Icon: XCircle,
  },
  info: {
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    border: 'border-blue-200 dark:border-blue-800',
    text: 'text-blue-700 dark:text-blue-300',
    Icon: Info,
  },
  warning: {
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    border: 'border-amber-200 dark:border-amber-800',
    text: 'text-amber-700 dark:text-amber-300',
    Icon: AlertTriangle,
  },
};

interface Props {
  type: AlertType;
  children: React.ReactNode;
  className?: string;
}

export default function Alert({ type, children, className = '' }: Props) {
  const { bg, border, text, Icon } = STYLES[type];
  return (
    <div className={`flex items-start gap-2 px-3 py-2 rounded-lg border text-sm ${bg} ${border} ${text} ${className}`}>
      <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <span>{children}</span>
    </div>
  );
}
